module.exports = __webpack_public_path__ + "img/UI_shouji_AZ_android_1280_3d5a2176b.png";